/*
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-12-11 18:18:56
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-13 09:16:32
 */
import axios from "axios";
import qs from "qs";

axios.defaults.timeout = 10000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.baseURL = process.env.baseURI;

//POST传参序列化
axios.interceptors.request.use(
  config => {
    if (config.method === "post") {
      let curPost = config.url.split("/")[config.url.split("/").length - 1];
      if (curPost === "uploadPicture") {
        return config;
      } else {
        config.data = qs.stringify(config.data);
        return config;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

function post(url, params, config) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then(
        response => {
          resolve(response.data);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}

function get(url, param) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: param
      })
      .then(
        response => {
          resolve(response.data);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}

export default { get, post };



// WEBPACK FOOTER //
// ./src/api/index.js